import React, { useState, useEffect } from 'react';
import Breadcumb from '../../Layouts/Breadcumb'
import { Grid, TextField } from '@mui/material'
import DashboardNav from './DashboardNav'
import Select from 'react-select';
import axios from 'axios';
import Searchcategory from '../Home/HomeSearch/Searchcategory';
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";
import { jwtDecode } from 'jwt-decode';
import { Constants } from '../../endPoints';

export default function Sellproduct() {
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [content, setContent] = useState('');
  const [selections, setSelections] = useState([]);
  const [categories, setCategories] = useState([]);
  const [shopForOptions, setShopForOptions] = useState([]);
  const [selectedSelection, setSelectedSelection] = useState(null); // New state to hold selected selection
  const [isSelectionLoading, setIsSelectionLoading] = useState(false);
  const [isCategoriesLoading, setIsCategoriesLoading] = useState(false);
  const [isShopForLoading, setIsShopForLoading] = useState(false);
  const [loading , setLoading] = useState(false);


  const [ringStyles, setRingStyles] = useState([]);
  const [isRingStylesLoading, setIsRingStylesLoading] = useState(false);

  const [clarityOptions, setClarityOptions] = useState([]);
  const [isClarityLoading, setIsClarityLoading] = useState(false);

  const [stoneColors, setStoneColors] = useState([]);
  const [isStoneColorsLoading, setIsStoneColorsLoading] = useState(false);

  const [pearlColors, setPearlColors] = useState([]);
  const [isPearlColorsLoading, setIsPearlColorsLoading] = useState(false);

  const [pearlTypes, setPearlTypes] = useState([]);
  const [isPearlTypesLoading, setIsPearlTypesLoading] = useState(false);

  const [diamondColors, setDiamondColors] = useState([]);
  const [isDiamondColorsLoading, setIsDiamondColorsLoading] = useState(false);

  const [imagePreviews, setImagePreviews] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [feedbackType, setFeedbackType] = useState('');
  const [resetKey, setResetKey] = useState(0);



  // Fetch countries
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${Constants.listCounty}`);
        setCountries(response.data.data);
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };
    fetchCountries();
  }, []);

  useEffect(() => {
    if (feedbackMessage) {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }, [feedbackMessage]);

  const fetchStates = async (countryId) => {
    const accessToken = localStorage.getItem('authToken');
    try {
      const response = await axios.get(`${Constants.getStatecountryById}/${countryId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setStates(response.data.data);
      setCities([]); // Clear cities when country changes
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  };

  const fetchCities = async (stateId) => {
    const accessToken = localStorage.getItem('authToken');
    try {
      const response = await axios.get(`${Constants.getCityStateById}/${stateId}`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      setCities(response.data.data);
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  useEffect(() => {
    const fetchSelections = async () => {
      setIsSelectionLoading(true);
      try {
        const response = await axios.get(Constants.listSelection);
        if (response.data.status === 1) {
          setSelections(response.data.list);
        }
      } catch (error) {
        console.error('Error fetching selections:', error);
      } finally {
        setIsSelectionLoading(false);
      }
    };

    fetchSelections();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      setIsCategoriesLoading(true);
      try {
        const response = await axios.get(Constants.listCategory);
        if (response.data.status === 1) {
          setCategories(response.data.list);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      } finally {
        setIsCategoriesLoading(false);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchShopForOptions = async () => {
      setIsShopForLoading(true);
      try {
        const response = await axios.get(Constants.listShopFor);
        if (response.data.status === 1) {
          setShopForOptions(response.data.list);
        }
      } catch (error) {
        console.error('Error fetching shopFor options:', error);
      } finally {
        setIsShopForLoading(false);
      }
    };

    fetchShopForOptions();
  }, []);


  useEffect(() => {
    const fetchRingStyles = async () => {
      setIsRingStylesLoading(true);
      try {
        const response = await axios.get(Constants.listRingStyle);
        if (response.data.status === 1) {
          setRingStyles(response.data.list); // Set ring styles options
        }
      } catch (error) {
        console.error('Error fetching ring styles:', error);
      } finally {
        setIsRingStylesLoading(false);
      }
    };

    fetchRingStyles();
  }, []);

  useEffect(() => {
    const fetchClarityOptions = async () => {
      setIsClarityLoading(true);
      try {
        const response = await axios.get(Constants.listClarity);
        if (response.data.status === 1) {
          setClarityOptions(response.data.list); // Set clarity options
        }
      } catch (error) {
        console.error('Error fetching clarity options:', error);
      } finally {
        setIsClarityLoading(false);
      }
    };

    fetchClarityOptions();
  }, []);

  useEffect(() => {
    const fetchStoneColors = async () => {
      setIsStoneColorsLoading(true);
      try {
        const response = await axios.get(Constants.listStoneColor);
        if (response.data.status === 1) {
          setStoneColors(response.data.list); // Set stone color options
        }
      } catch (error) {
        console.error('Error fetching stone colors:', error);
      } finally {
        setIsStoneColorsLoading(false);
      }
    };

    fetchStoneColors();
  }, []);

  useEffect(() => {
    const fetchPearlColors = async () => {
      setIsPearlColorsLoading(true);
      try {
        const response = await axios.get(Constants.listPearlColor);
        if (response.data.status === 1) {
          setPearlColors(response.data.list); // Set pearl color options
        }
      } catch (error) {
        console.error('Error fetching pearl colors:', error);
      } finally {
        setIsPearlColorsLoading(false);
      }
    };

    fetchPearlColors();
  }, []);

  useEffect(() => {
    const fetchPearlTypes = async () => {
      setIsPearlTypesLoading(true);
      try {
        const response = await axios.get(Constants.listPearlType);
        if (response.data.status === 1) {
          setPearlTypes(response.data.list); // Set pearl type options
        }
      } catch (error) {
        console.error('Error fetching pearl types:', error);
      } finally {
        setIsPearlTypesLoading(false);
      }
    };

    fetchPearlTypes();
  }, []);

  useEffect(() => {
    const fetchDiamondColors = async () => {
      setIsDiamondColorsLoading(true);
      try {
        const response = await axios.get(Constants.listDiamondColor);
        if (response.data.status === 1) {
          setDiamondColors(response.data.list); // Set diamond color options
        }
      } catch (error) {
        console.error('Error fetching diamond colors:', error);
      } finally {
        setIsDiamondColorsLoading(false);
      }
    };

    fetchDiamondColors();
  }, []);


  const handleChange = (value) => {
    setContent(value);
  };



  // const countryOptions = countries.map(country => ({
  //   value: country.id,
  //   label: (
  //     <div style={{ display: 'flex', alignItems: 'center' }}>
  //       <img
  //         src={`${country.country_symbols}`}
  //         alt={`${country.country} Flag`}
  //         style={{ width: '20px', marginRight: '10px' }}
  //       />
  //       {country.country}
  //     </div>
  //   ),
  // }));
  const countryOptions = countries.map(country => ({
    value: country.id,
    label: country.country, // ✅ text for search
    image: country.country_symbols // ✅ flag
  }));

  // const stateOptions = states.map(state => ({ value: state.id, label: state.name }));
  const stateOptions = states
    .sort((a, b) => a.name.localeCompare(b.name)) // ✅ sort ascending
    .map(state => ({
      value: state.id,
      label: state.name
    }));
  const cityOptions = cities.map(city => ({ value: city.id, label: city.name }));

  // const selectionOptions = selections.map((selection) => ({
  //   value: selection.id,
  //   label: (
  //     <div style={{ display: 'flex', alignItems: 'center' }}>
  //       <img
  //         src={`${Constants.imageBaseURL}/${selection.image}`} // Assuming `imageBaseURL` is the base URL for images
  //         alt={selection.name}
  //         style={{ width: '20px', marginRight: '10px' }}
  //       />
  //       {selection.name}
  //     </div>
  //   ),
  // }));

  const selectionOptions = selections.map((selection) => ({
    value: selection.id,
    label: selection.name, // ✅ text
    image: `${Constants.imageBaseURL}/${selection.image}` // ✅ image
  }));

  // const categoryOptions = categories.map((category) => ({
  //   value: category.id,
  //   label: (
  //     <div style={{ display: 'flex', alignItems: 'center' }}>
  //       <img
  //         src={`${Constants.imageBaseURL}/${category.image}`} // Assuming `imageBaseURL` is the base URL for images
  //         alt={category.name}
  //         style={{ width: '20px', marginRight: '10px' }}
  //       />
  //       {category.name}
  //     </div>
  //   ),
  // }));

  const categoryOptions = categories.map((category) => ({
    value: category.id,
    label: category.name, // ✅ text
    image: `${Constants.imageBaseURL}/${category.image}` // ✅ image
  }));

  const shopForOptionsMapped = shopForOptions.map((shopFor) => ({
    value: shopFor.id,
    label: shopFor.name,
  }));

  const ringStyleOptionsMapped = ringStyles.map((ringStyle) => ({
    value: ringStyle.id,
    label: ringStyle.name,
  }));

  const stoneColorOptionsMapped = stoneColors.map((stoneColor) => ({
    value: stoneColor.id,
    label: stoneColor.name,
  }));

  const diamondColorOptionsMapped = diamondColors.map((diamondColor) => ({
    value: diamondColor.id,
    label: diamondColor.name,
  }));

  const clarityOptionsMapped = clarityOptions.map((clarity) => ({
    value: clarity.id,
    label: clarity.name,
  }));

  const pearlColorOptionsMapped = pearlColors.map((pearlColor) => ({
    value: pearlColor.id,
    label: pearlColor.name,
  }));

  const pearlTypeOptionsMapped = pearlTypes.map((pearlType) => ({
    value: pearlType.id,
    label: pearlType.name,
  }));

  const handleFileChange = (e) => {
    const files = e.target.files;
    const filesArray = Array.from(files);

    // Create blob URLs for image previews
    const previews = filesArray.map(file => URL.createObjectURL(file));

    setImagePreviews((prevPreviews) => [...prevPreviews, ...previews]);  // Append new previews
    setSelectedFiles((prevFiles) => [...prevFiles, ...filesArray]);  // Append new files
  };

  const [formData, setFormData] = useState({
    country: '',
    state: '',
    city: '',
    selection: '',
    category: '',
    shopFor: '',
    ringStyle: '',
    stoneColor: '',
    diamondColor: '',
    clarity: '',
    pearlColor: '',
    pearlType: '',
    description: '',
    price: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleRemoveImage = (indexToRemove) => {
    setImagePreviews((prev) => prev.filter((_, i) => i !== indexToRemove));
    setSelectedFiles((prev) => prev.filter((_, i) => i !== indexToRemove));
  };

  const validateForm = () => {
    if (!formData.country) return "Country is required";
    if (!formData.state) return "State is required";
    if (!formData.city) return "City is required";
    if (!formData.selection) return "Main Selection is required";

    // Category required only for some selections
    if ([1, 2, 3, 4, 5, 8].includes(selectedSelection) && !formData.category) {
      return "Category is required";
    }

    if (!formData.shopFor) return "Shop For is required";

    if (!content || content.trim() === "") return "Description is required";

    if (selectedFiles.length === 0) return "At least one product image is required";

    return null;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const error = validateForm();
    if (error) {
      setFeedbackMessage(error);
      setFeedbackType("error");
      return; // ❌ STOP SUBMIT
    }
    const accessToken = localStorage.getItem('authToken');
    const formDataToSubmit = new FormData();
    if (!accessToken) {
      console.error('No access token found');
      return;
    }
    const decodedToken = jwtDecode(accessToken);
    // Assuming the user ID is stored as 'id' in the decoded token
    const idUser = decodedToken.id;
    formDataToSubmit.append('idUser', idUser);
    formDataToSubmit.append('idCountry', formData.country);
    formDataToSubmit.append('idState', formData.state);
    formDataToSubmit.append('idCity', formData.city);
    formDataToSubmit.append('idSelection', formData.selection);
    formDataToSubmit.append('idCategory', formData.category);
    formDataToSubmit.append('idShopFor', formData.shopFor);
    formDataToSubmit.append('idRingStyle', formData.ringStyle);
    formDataToSubmit.append('idStoneColor', formData.stoneColor);
    formDataToSubmit.append('idDiamondColor', formData.diamondColor);
    formDataToSubmit.append('idClarity', formData.clarity);
    formDataToSubmit.append('idPearlColor', formData.pearlColor);
    formDataToSubmit.append('idPearlType', formData.pearlType);
    formDataToSubmit.append('description', content);
    if (selectedFiles.length > 0) {
      selectedFiles.forEach((file) => {
        formDataToSubmit.append('images', file); // Append each file to the FormData
      });
    }
    try {
      setLoading(true);
      const response = await axios.post(`${Constants.addProduct}`, formDataToSubmit, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data.success === 1) {
        setFeedbackMessage('Product added successfully. It is currently under review by the admin.');
        setFeedbackType('success'); // Set feedback type to success

        // Reset the form data
        setFormData({
          country: '',
          state: '',
          city: '',
          selection: '',
          category: '',
          shopFor: '',
          ringStyle: '',
          stoneColor: '',
          diamondColor: '',
          clarity: '',
          pearlColor: '',
          pearlType: '',
          description: '',
          price: ''
        });
        setContent('');
        // Clear selected files
        setSelectedFiles([]);
        setImagePreviews([]);
        setSelectedSelection('');
        if (document.getElementById('fileInput')) {
          document.getElementById('fileInput').value = ''; // Clear the file input field
        }
        setResetKey(prevKey => prevKey + 1);
        setLoading(false);
      } else {
        setFeedbackMessage('Failed to create product.');
        setFeedbackType('error'); // Set feedback type to error
        setLoading(false);
      }
    } catch (error) {
      console.error('Error creating product:', error);
      setFeedbackMessage('An error occurred while creating the product.');
      setFeedbackType('error'); // Set feedback type to error
      setLoading(false);
    }
  };

  return (
    <>
      <Breadcumb pagetitle="Sell Product" />
      <section className='py-12 dashboardsec'>
        <div className='container mx-auto px-4'>
          <Grid container spacing={5}>
            <Grid item lg={3} md={12} sm={12} xs={12}>
              <DashboardNav />
            </Grid>
            <Grid item lg={9} md={12} sm={12} xs={12}>
              {feedbackMessage && (
                <div
                  style={{
                    marginTop: "16px",       // mt-4
                    padding: "16px",         // p-4
                    textAlign: "center",     // text-center
                    borderRadius: "6px",     // rounded-md
                    backgroundColor: feedbackType === 'success' ? "#D1FAE5" : "#FEE2E2", // bg-green-100 / bg-red-100
                    color: feedbackType === 'success' ? "#047857" : "#B91C1C",           // text-green-700 / text-red-700
                  }}
                >
                  {feedbackMessage}
                </div>
              )}
              <form className="form-profile" key={resetKey} onSubmit={handleSubmit}>
                <h2 className='text-3xl font-bold headningfont mb-3'>Add New Product </h2>
                <Grid container spacing={3}>
                  {/* Country, State, City Selections */}
                  <Grid item lg={5} md={6} sm={12} xs={12}>
                    <label className='mb-3 block font-semibold'>Country <span className='text-red-500'>*</span></label>
                    {/* <Select
                      options={countryOptions}
                      onChange={(option) => {
                        setFormData((prev) => ({ ...prev, country: option.value }));
                        fetchStates(option.value);  // Fetch states based on country selection
                      }}
                      placeholder="Select Country"
                      isSearchable
                    /> */}

                    {/* <Select
                      options={countryOptions}
                      placeholder="Select Country"
                      isSearchable

                      formatOptionLabel={(option) => (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <img
                            src={option.image}
                            style={{ width: '20px', marginRight: '10px' }}
                          />
                          {option.label}
                        </div>
                      )}

                      onChange={(option) => {
                        setFormData((prev) => ({ ...prev, country: option.value }));
                        fetchStates(option.value);
                      }}
                    /> */}

                    <Select
                      options={countryOptions}
                      placeholder="Select Country"
                      isSearchable

                      value={countryOptions.find(c => c.value === formData.country) || null} // ✅ ADD THIS

                      formatOptionLabel={(option) => (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <img src={option.image} style={{ width: '20px', marginRight: '10px' }} />
                          {option.label}
                        </div>
                      )}

                      onChange={(option) => {
                        setFormData((prev) => ({
                          ...prev,
                          country: option ? option.value : '',
                          state: '',   // ✅ CLEAR
                          city: ''     // ✅ CLEAR
                        }));

                        setStates([]);
                        setCities([]);

                        if (option) fetchStates(option.value);
                      }}
                    />
                  </Grid>
                  <Grid item lg={5} md={6} sm={12} xs={12}>
                    <label className='mb-3 block font-semibold'>State <span className='text-red-500'>*</span></label>
                    <Select
                      options={stateOptions}
                      placeholder="Select State"
                      isSearchable

                      value={stateOptions.find(s => s.value === formData.state) || null} // ✅ ADD

                      onChange={(option) => {
                        setFormData((prev) => ({
                          ...prev,
                          state: option ? option.value : '',
                          city: '' // ✅ CLEAR CITY
                        }));

                        setCities([]);

                        if (option) fetchCities(option.value);
                      }}
                    />
                  </Grid>
                  <Grid item lg={5} md={6} sm={12} xs={12}>
                    <label className='mb-3 block font-semibold'>City <span className='text-red-500'>*</span></label>
                    {/* <Select
                      options={cities.map((city) => ({ value: city.id, label: city.name }))}
                      onChange={(option) => setFormData((prev) => ({ ...prev, city: option.value }))}
                      placeholder="Select City"
                      isSearchable
                    /> */}

                    <Select
                      options={cityOptions}
                      placeholder="Select City"
                      isSearchable

                      value={cityOptions.find(c => c.value === formData.city) || null} // ✅ ADD

                      onChange={(option) =>
                        setFormData((prev) => ({
                          ...prev,
                          city: option ? option.value : ''
                        }))
                      }
                    />
                  </Grid>

                  {/* Main Selection (Dynamic Dropdown) */}
                  <Grid item lg={5} md={6} sm={12} xs={12}>
                    <label className="mb-3 block font-semibold">
                      Main Selection <span className="text-red-500">*</span>
                    </label>
                    {/* <Select
                      options={selectionOptions}
                      onChange={(option) => {
                        setFormData((prev) => ({ ...prev, selection: option.value }));
                        setSelectedSelection(option.value);
                      }}
                      placeholder="Select Main Selection"
                      isSearchable
                    /> */}

                    <Select
                      options={selectionOptions}
                      placeholder="Select Main Selection"
                      isSearchable

                      formatOptionLabel={(option) => (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          <img
                            src={option.image}
                            style={{ width: '20px', marginRight: '10px' }}
                          />
                          {option.label}
                        </div>
                      )}

                      onChange={(option) => {
                        setFormData((prev) => ({ ...prev, selection: option.value }));
                        setSelectedSelection(option.value);
                      }}
                    />
                  </Grid>
                  {selectedSelection == 1 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        {/* <Select
                          options={categoryOptions}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, category: option.value }))
                          }
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        /> */}

                        <Select
                          options={categoryOptions}
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}

                          formatOptionLabel={(option) => (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <img
                                src={option.image}
                                style={{ width: '20px', marginRight: '10px' }}
                              />
                              {option.label}
                            </div>
                          )}

                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, category: option.value }))
                          }
                        />
                      </Grid>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, shopFor: option.value }))
                          }
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>
                    </>
                  )}


                  {selectedSelection == 4 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, category: option.value }))
                          }
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                      </Grid>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, shopFor: option.value }))
                          }
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>
                    </>
                  )}

                  {selectedSelection == 2 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, category: option.value }))
                          }
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, shopFor: option.value }))
                          }
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>


                      {/* <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Ring Style <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={ringStyleOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, ringStyle: option.value }))
                          }
                          placeholder="Select Ring Style"
                          isSearchable
                          isLoading={isRingStylesLoading}
                        />
                      </Grid> */}
                      {/* 
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Diamond Color <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={diamondColorOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, diamondColor: option.value }))
                          }
                          placeholder="Select diamond color"
                          isSearchable
                          isLoading={isDiamondColorsLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Clarity <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={clarityOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, clarity: option.value }))
                          }
                          placeholder="Select clarity"
                          isSearchable
                          isLoading={isClarityLoading}
                        />
                      </Grid> */}

                    </>
                  )}

                  {selectedSelection == 8 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, category: option.value }))
                          }
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, shopFor: option.value }))
                          }
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>

                      {/* <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Ring Style <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={ringStyleOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, ringStyle: option.value }))
                          }
                          placeholder="Select Ring Style"
                          isSearchable
                          isLoading={isRingStylesLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Stone Color <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={stoneColorOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, stoneColor: option.value }))
                          }
                          placeholder="Select Stone Color"
                          isSearchable
                          isLoading={isStoneColorsLoading}
                        />
                      </Grid> */}
                    </>
                  )}

                  {selectedSelection == 5 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, category: option.value }))
                          }
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, shopFor: option.value }))
                          }
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>

                      {/* <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Pearl Color <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={pearlColorOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, pearlColor: option.value }))
                          }
                          placeholder="Select Pearl Color"
                          isSearchable
                          isLoading={isPearlColorsLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Pearl Type <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={pearlTypeOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, pearlType: option.value }))
                          }
                          placeholder="Select Pearl Type"
                          isSearchable
                          isLoading={isPearlTypesLoading}
                        />
                      </Grid> */}
                    </>
                  )}


                  {selectedSelection == 3 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, category: option.value }))
                          }
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                      </Grid>

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, shopFor: option.value }))
                          }
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>
                    </>
                  )}

                  {selectedSelection == 7 && (
                    <>
                      {/* <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Category <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={categoryOptions}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, category: option.value }))
                          }
                          placeholder="Select Category"
                          isSearchable
                          isLoading={isCategoriesLoading}
                        />
                      </Grid> */}

                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, shopFor: option.value }))
                          }
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>
                    </>
                  )}

                  {selectedSelection == 6 && (
                    <>
                      <Grid item lg={5} md={6} sm={12} xs={12}>
                        <label className="mb-3 block font-semibold">
                          Shop For <span className="text-red-500">*</span>
                        </label>
                        <Select
                          options={shopForOptionsMapped}
                          onChange={(option) =>
                            setFormData((prev) => ({ ...prev, shopFor: option.value }))
                          }
                          placeholder="Select Shop For"
                          isSearchable
                          isLoading={isShopForLoading}
                        />
                      </Grid>
                    </>
                  )}


                  {/* Product Image Upload */}
                  <Grid item lg={5} md={6} sm={12} xs={12}>
                    <label className="mb-3 block font-semibold">
                      Product Images <span className="text-red-500">*</span>
                    </label>

                    <div className="mb-2">
                      <label className="customfiles m-0 w-[120px] h-[100px] border py-4 px-2 rounded-lg text-center inline-block cursor-pointer">
                        <input
                          type="file"
                          accept="image/png, image/jpeg, image/jpg"
                          className="hidden"
                          onChange={handleFileChange}
                          multiple
                          id="fileInput"
                        />
                        {/* <i className="fa-regular fa-camera text-4xl mb-2"></i> */}
                        <i className="fa-solid fa-camera text-4xl mb-2"></i>

                        <p className="text-xs text-gray-500">Browse Files...</p>
                      </label>
                    </div>

                    {/* Display previews of all selected images with remove button */}
                    <div className="flex flex-wrap gap-2 mt-2">
                      {imagePreviews.map((preview, index) => (
                        <div key={index} className="relative w-24 h-24 border rounded-md overflow-hidden">
                          <img
                            src={preview}
                            alt={`Preview ${index}`}
                            className="w-full h-full object-cover"
                          />
                          <button
                            type="button"
                            onClick={() => handleRemoveImage(index)}
                            className="closebtns absolute top-1 right-1 bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-800"
                            title="Remove"
                          >
                            &times;
                          </button>
                        </div>
                      ))}
                    </div>

                    <p
                      style={{
                        fontSize: "12px",
                        color: "red",
                        marginTop: "4px",
                      }}
                    >
                      Image Type: (W: 800px, H: 1100px) PNG, JPEG, JPG
                    </p>
                  </Grid>

                  {/* Description Editor */}
                  {/* <Grid item lg={10} md={6} sm={12} xs={12}>
                    <label className='mb-3 block font-semibold'>Description <span className='text-red-500'>*</span></label>
                    <ReactQuill theme="snow" value={content} onChange={handleChange} className='h-[180px] mb-8' />
                  </Grid> */}

                  <Grid item lg={10} md={6} sm={12} xs={12}>
                    <label
                      style={{
                        marginBottom: "12px",
                        display: "block",
                        fontWeight: "600"
                      }}
                    >
                      Description <span style={{ color: "#ef4444" }}>*</span>
                    </label>

                    <ReactQuill
                      theme="snow"
                      value={content}
                      onChange={handleChange}
                      style={{
                        height: "180px",
                        marginBottom: "32px"
                      }}
                    />
                  </Grid>

                  {/* Submit Button */}
                  <Grid item lg={10} md={6} sm={12} xs={12} style={{marginTop: "16px"}}>
                    <button className="inline-block submit_btn h-14 px-8 border rounded bg-[#b3902d] min-w-32 text-white font-semibold" disabled={loading}>
                      {loading ? "Publishing..." : "Publish"}
                    </button>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </div>
      </section>
    </>
  );
}
